import { render, staticRenderFns } from "./VoyageMapPopup.vue?vue&type=template&id=2c5d3fd6&scoped=true&"
import script from "./VoyageMapPopup.vue?vue&type=script&lang=js&"
export * from "./VoyageMapPopup.vue?vue&type=script&lang=js&"
import style0 from "./VoyageMapPopup.vue?vue&type=style&index=0&id=2c5d3fd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5d3fd6",
  null
  
)

export default component.exports